import { createSelector, createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";

const publicGroupSlice = createSlice({
    name: 'publicGroup',
    initialState: {
        data: {}
    },
    reducers: {
        set: (state, action) => {
            ensureArray(action.payload).forEach(group => state.data[group.code] = group);
        },
        setSingle: (state, action) => {
            state.data[action.payload.code] = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const group of ensureArray(action.payload)) {
                state.data[group.code] = group;
            };
        },
        remove: (state, action) => {
            for (const group of ensureArray(action.payload)) {
                delete state.data[group.code];
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => publicGroupSlice.getInitialState());
    }
});

// #region network opreations
const fetchGroup = code => network => network.get('/api/v1/publicgroup/' + encodeURIComponent(code), publicGroupSlice.actions.addOrUpdate);
// #endregion

// #region selectors
const selectGroupData = state => state.publicGroup.data;
const createSelectGroup = createSelector([selectGroupData, (state, code) => code], (groupMap, code) => groupMap[code]);
const selectGroup = code => state => createSelectGroup(state, code);
// #endregion

// #region listeners
const registerGroupListeners = (register, dispatch, network, credentials) => {
    const cleanup = [
    ];
    return () => cleanup.forEach(c => c());
}
// #endregion

const initByID = initMapFactory(fetchGroup, registerGroupListeners, { authenticated: false });
export const [usePublicGroup] = dataHookFactory(selectGroup, initByID);

const reducerDetails = { name: publicGroupSlice.name, reducer: publicGroupSlice.reducer };
export default reducerDetails;